// https://react.i18next.com/latest/using-with-hooks
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import i18n_br from './i18n_br';
import i18n_en from './i18n_en';
import i18n_fr from './i18n_fr';

export const languages = {
  br: 'br',
  en: 'en',
  fr: 'fr',
};

export const config = {
  lng: languages.fr,
  fallbackLng: languages.fr,
  debug: true,
  resources: {
    [ languages.br ]: {
      translation: i18n_br,
    },
    [ languages.en ]: {
      translation: i18n_en,
    },
    [ languages.fr ]: {
      translation: i18n_fr,
    },
  },
};

i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init(config)
  .then(() => {console.log('i18n setup');});

export default i18n;
